/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  useGetProductsFromSimulation,
  useGetSimulators,
} from "./useSimulatorsQuery";
import useSimulatorsStore from "./useSimulatorsStore";
import { useNavigate, useParams } from "react-router-dom";

import { initialPath } from "~misc/paths";
import { money } from "~hooks/useHelpers";
import { getLocalStorage, removeLocalStorage } from "~services/utils/SaveIndexBD";

const removeAccents = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

const useSimulators = () => {
  const [filters, setFilters] = useState({
    busca: "",
    periodo: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const simulations = useGetSimulators();
  const { parameter: idCliente } = useParams();
  const [simulacaoProduto, setSimulacaoProduto] = useState({});

  useEffect(() => {
    const filterSimulations = () => {
      const { busca, periodo } = filters;

      if (simulations.data) {
        // Função para remover acentos
        const removeAccents = (str) =>
          str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        let filteredResults = simulations.data.filter((item) => {
          const nome = item.razaoSocial || "";
          const idCliente = item.idCliente.toString() || ""; // Converter para string aqui

          // Filtro combinado para razaoSocial e idCliente
          return (
            removeAccents(nome)
              .toLowerCase()
              .includes(removeAccents(busca).toLowerCase()) ||
            idCliente.toLowerCase().includes(busca.toLowerCase())
          );
        });

        if (periodo) {
          let sorted;
          if (periodo === "recente" || periodo === "") {
            sorted = filteredResults.sort((a, b) => {
              const dataA = new Date(a.createdAt.split("-")[0].split("/").reverse().join("/"));
              const dataB = new Date(b.createdAt.split("-")[0].split("/").reverse().join("/"));
              return dataB - dataA;
            });
            setFilteredData(sorted);
          } else if (periodo === "antigo") {
            sorted = filteredResults.sort((a, b) => {
              const dataA = new Date(a.createdAt.split("-")[0].split("/").reverse().join("/"));
              const dataB = new Date(b.createdAt.split("-")[0].split("/").reverse().join("/"));
              return dataA - dataB;
            });
            setFilteredData(sorted);
          } else {
            sorted = filteredResults;
            setFilteredData(sorted);
          }
        } else {
          setFilteredData(filteredResults);
        }
      }
    };

    filterSimulations();
  }, [filters, simulations.data]);

  const { products, getProductsByGroup, groupProductsByGroup } =
    useSimulatorsStore();


  async function fetchProdutosEditSimulacao() {
    const data = getLocalStorage('simulacao-edit-produto' + idCliente, true);
    if (data) {
      setSimulacaoProduto(data);
    }
  }

  async function desfetchProdutosEditSimulacao() {
    removeLocalStorage('simulacao-edit-produto' + idCliente);
  }

  useEffect(() => {
    fetchProdutosEditSimulacao();
  }, [])

  return {
    simulacaoProduto,
    filters,
    setFilters,
    filteredData,
    simulations,
    products,
    getProductsByGroup,
    groupProductsByGroup,
    desfetchProdutosEditSimulacao,
  };
};

export default useSimulators;
